import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {FluencyResponse, ISelectionResponse, PointsResponse, RecordingWCPM, ReviewWord} from "../../reports/reports.objects";
import {ClientConfiguration} from "../configuration/client.config";
import {Login} from "../../login/login";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable()
export class ReportsService {

    private tableListRange: number = 3;
    private getOptions = { withCredentials: true };
    constructor(private http:HttpClient, private config:ClientConfiguration, private login:Login) {
    }

    private determineColorWeight(wordColor: string): number {
        switch (wordColor) {
            case "red":
                return 3;
            case "blue":
                return 2;
            default:
                return 1;
        }
    }

    private isColorWeightChangeNeeded(origWordColor: string, newWordColor: string): boolean {
        return this.determineColorWeight(newWordColor) > this.determineColorWeight(origWordColor);
    }

    /*
    Endpoint in SLC : com.scilearn.gwe.admin.rsservices.ra.RALearnerResource#downloadFluencyReport
    example http:
    GET /slc/services/ra/learner/FluencyReport/185348/b1b68246189d7546f050b17ec506dd93/35_52_C2_1_Revolutio_4120_607?httpSessionId=4fd1a468479ac5361c4517b140c08c39
     */
    public retrieveFluencyReport(title:string):Observable<FluencyResponse> {
        let url = this.config.isSuperUserMode
            ? "base/test/json/fluency.json"
            : this.config.fluencyReportPath + this.login.tenantId + "/" + this.login.learnerId + "/" + encodeURIComponent(title) + "?httpSessionId=" + this.login.sessionId;
        return this.http.get(url, this.getOptions) as Observable<FluencyResponse>;
    }

    /*
    Engpoint in SLC : com.scilearn.gwe.admin.rsservices.ra.RALearnerResource#downloadSelectionReportOf
    example http:
    GET /slc/services/ra/learner/SelectionReport/185348/b1b68246189d7546f050b17ec506dd93/35_52_C2_1_Revolutio_4120_607?httpSessionId=4fd1a468479ac5361c4517b140c08c39
     */
    public retrieveSelectionReport(title):Observable<ISelectionResponse> {
        let url = this.config.isSuperUserMode
            ? "base/test/json/selection.json"
            : this.config.selectionReportPath + this.login.tenantId + "/" + this.login.learnerId + "/" +
        encodeURIComponent(title) + "?httpSessionId=" + this.login.sessionId;
        return this.http.get(url, this.getOptions) as Observable<ISelectionResponse>;
    }

    /*
    Endpoint in SLC : com.scilearn.gwe.admin.rsservices.ra.RALearnerResource#downloadPointsOf
    example http:
    GET /slc/services/ra/learner/PointsReport/185348/b1b68246189d7546f050b17ec506dd93/35_52_C2_1_Revolutio_4120_607?httpSessionId=4fd1a468479ac5361c4517b140c08c39
    */
    public retrievePointsReport():Observable<PointsResponse> {
        let url = this.config.isSuperUserMode
            ? "base/test/json/points.json"
            : this.config.pointsReportPath + this.login.tenantId + "/" + this.login.learnerId + "?httpSessionId=" + this.login.sessionId;
        return this.http.get(url, this.getOptions) as Observable<PointsResponse>;
    }

    public outputBufferedList(maxOutput: number, list: ReviewWord[]): ReviewWord[] {
        if (list.length > maxOutput) {
            return list;
        }

        let output = [];
        for (let i = 0; i < maxOutput; i++) {
            if (!!list[i]) {
                output[i] = list[i];
            } else {
                output[i] = undefined;
            }
        }
        return output;
    }

    public getTableListRange(): Array<boolean> {
        return Array(this.tableListRange).fill(true);
    }

    public getReviewWordsTable(index: number, list: ReviewWord[]): ReviewWord[] {
        let startIndex = index === 0 ? 0 : index * 5;
        let endIndex = index === 0 ? 5 : ((index + 1) * 5);
        let output = list.slice(startIndex, endIndex);
        if (output.length > 5) {
            return output;
        } else {
            return this.outputBufferedList(5, output);
        }
    }

    public printReport(id: string): void {
        let popupWindow;
        let innerContents = document.getElementById(id).innerHTML;
        popupWindow = window.open("", "_blank", "width=845,height=1100,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no");
        popupWindow.document.open();
        popupWindow.document.write("<html><head><title>Print View for Report</title><link rel='stylesheet' type='text/css' href='css/aggregated-report.css' /></head><body class='for-print' onload='window.print()'>" + innerContents + "</html>");
        popupWindow.document.close();
    }

    public filterOutDuplicateWords(list: ReviewWord[]): ReviewWord[] {
        let wordMap = {};
        for (let word of list) {
            let wordLower = word.word.toLowerCase();
            if (!wordMap[wordLower]) {
                wordMap[wordLower] = word;
            } else if (this.isColorWeightChangeNeeded(wordMap[wordLower].wordColor, word.wordColor)) {
                wordMap[wordLower] = word;
            }
        }
        return Object.keys(wordMap).map((key) => wordMap[key]);
    }

}


